import { FrontendApp } from './FrontendApp';
import { AuthService, createAuthService } from './services/AuthService';
import { UserService, User, createUserService } from './services/UserService';
import {
  SYNC_PROP_SELF_TENANT_UUID,
  SYNC_PROP_TENANT_UUID,
  SYNC_PROP_LANGUAGE,
  SYNC_PROP_BRANDING
} from './constants';

function createContainer(): HTMLElement {
  const container: HTMLElement = document.createElement('div');

  container.setAttribute('class', 'frontend-app-container');
  document.body.appendChild(container);

  return container;
}

export async function mountFrontendApp(frontendApp: FrontendApp): Promise<void> {
  if (process.env.NODE_ENV === 'development') {
    const authService: AuthService = createAuthService({
      target: process.env.VUE_APP_TARGET,
      userName: process.env.VUE_APP_USER_NAME,
      password: process.env.VUE_APP_PASSWORD
    });
    await authService.login();
  }
  const userService: UserService = createUserService();
  const user: User | null = await userService.getUser();

  if (user) {
    const container: HTMLElement = createContainer();
    await frontendApp.mount({
      container,
      syncProps: {
        [SYNC_PROP_SELF_TENANT_UUID]: user.selfTenantUuid,
        [SYNC_PROP_TENANT_UUID]: user.selfTenantUuid,
        [SYNC_PROP_LANGUAGE]: user.language,
        [SYNC_PROP_BRANDING]: user.branding
      }
    });
  } else {
    console.warn('All or a part of the required sync props are not received!');
  }
}
